if (!customElements.get('nc-prairie-builder')) {
  customElements.define('nc-prairie-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.products = config.products;
      this.specifications = config.specifications || [[30,12.569,110.71],[21,1.352,21.83],[23,.648,5.89]];
      this.recipeRows = JSON.parse(this.querySelector('[data-species]')?.textContent || '[]');
      this.componentIndexes = this.dataset.optionalBase === 'true' ? [0,1,2] : [this.products[0]?.handle?.startsWith('expanded-') ? 1 : this.products[0]?.handle?.startsWith('maximum-') ? 2 : 0];
      this.words = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type=submit]');
      this.status = this.querySelector('[data-status]');
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      const requestedId = new URLSearchParams(window.location.search).get('variant');
      const initialId = requestedId || this.dataset.initialVariant;
      const initial = this.products[0]?.variants?.find(v => String(v.id) === initialId);
      const initialTenths = this.coverageOf(initial);
      const coverage = this.querySelector('[name=coverage_size]');
      if (initial?.title === '1,000 sq ft') coverage.value = 'packet';
      else if (initialTenths === 2.5) coverage.value = 'quarter';
      else if (Number.isInteger(initialTenths) && initialTenths >= 5 && initialTenths <= 50) {
        coverage.value = 'other';
        this.querySelector('[name=acreage]').value = String(initialTenths / 10);
      }
      else if (initialId) {
        const option = document.createElement('option'); option.value=''; option.textContent=this.words.unsupportedInitial;
        coverage.prepend(option); coverage.value=''; this.unsupportedInitial=true;
      }
      coverage.addEventListener('change', () => {this.unsupportedInitial=false;});
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', event => {event.preventDefault(); this.submit();});
      this.update();
      this.organizeDetails();
    }
    organizeDetails() {
      const scope = this.closest('product-info') || this.closest('.shopify-section') || this.parentElement;
      const copy = scope.querySelector('.nc-product-copy');
      if (!copy || copy.dataset.organized === 'true') return;
      const headings = this.words.detailGroups?.split('|');
      if (!headings || headings.length !== 7) return;
      const nodes = Array.from(copy.childNodes);
      const groups = headings.map((heading, index) => {
        const wrapper = document.createElement('div'); wrapper.className = 'product__accordion accordion nc-prairie__content-group';
        const details = document.createElement('details'); details.id = 'PrairieDetails-' + this.dataset.sectionId + '-' + index;
        const summary = document.createElement('summary');
        const title = document.createElement('div'); title.className = 'summary__title';
        const h = document.createElement('h2'); h.className = 'h4 accordion__title inline-richtext'; h.textContent = heading; title.append(h); summary.append(title);
        const caret = this.querySelector('.nc-prairie__selection-details .icon-caret');
        if (caret) summary.append(caret.cloneNode(true));
        const body = document.createElement('div'); body.className = 'accordion__content rte';
        details.append(summary, body); wrapper.append(details);
        return {wrapper, body, details};
      });
      let group = 0;
      let inCircle = false;
      const circle = document.createElement('section');
      circle.className = 'nc-prairie__stewardship-circle';
      const routes = {
        'Choose the diversity that fits your project': 1,
        'Site conditions': 0,
        'Coverage sizes and 1,000 sq ft specifications': 3,
        'Blend ingredients': 2,
        'Why these species belong in the planting': 2,
        'Informed by established ecological restoration practice': 4,
        'Make your restoration budget go further': 4,
        'Planting and establishment': 5,
        'Ordering details': 5
      };
      nodes.forEach(node => {
        if (node.nodeType === 1 && node.tagName === 'STYLE') return;
        if (node.nodeType === 1 && node.tagName === 'H2') {
          inCircle = node.textContent.trim() === 'Make your restoration budget go further';
        }
        if (inCircle) { circle.append(node); return; }
        if (node.nodeType === 1 && node.id === 'mix-specifications') group = 6;
        else if (node.nodeType === 1 && node.tagName === 'H2' && Object.hasOwn(routes, node.textContent.trim())) group = routes[node.textContent.trim()];
        groups[group].body.append(node);
      });
      const diversityGuidance = this.querySelector('[data-intro-diversity]');
      if (diversityGuidance) groups[4].body.prepend(diversityGuidance);
      const selectedDetails = this.querySelector('[data-selected-details]');
      const selectedBody = selectedDetails?.querySelector('.accordion__content');
      const componentReference = scope.querySelector('.nc-prairie__reference');
      const consolidateSpecs = selectedBody && componentReference;
      groups.forEach(({wrapper, body}, index) => {
        if (index === 6 && consolidateSpecs) return;
        if (body.textContent.trim()) copy.append(wrapper);
        if (index === 4 && circle.textContent.trim()) copy.append(circle);
      });
      if (consolidateSpecs) {
        selectedDetails.id = 'mix-specifications';
        selectedBody.append(componentReference);
      }
      copy.dataset.organized = 'true';
      const optionalPlanner = scope.querySelector('.nc-prairie-planner');
      const descriptionBlock = copy.closest('.product__description');
      if (optionalPlanner && descriptionBlock) descriptionBlock.after(optionalPlanner);
      const revealAnchor = () => {
        if (!window.location.hash) return;
        let id; try { id = decodeURIComponent(window.location.hash.slice(1)); } catch (_) { return; }
        const target = document.getElementById(id);
        if (!target || !scope.contains(target)) return;
        if (target.tagName === 'DETAILS') target.open = true;
        for (let ancestor = target.parentElement; ancestor && ancestor !== scope; ancestor = ancestor.parentElement) if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        target.scrollIntoView({block:'start'});
      };
      copy.addEventListener('click', event => {
        const anchor = event.target.closest('a[href^="#"]');
        if (anchor) requestAnimationFrame(revealAnchor);
      });
      window.addEventListener('hashchange', revealAnchor);
      revealAnchor();
    }
    coverageOf(variant) {
      const title = variant?.title?.trim();
      if (title === '1/4 Acre') return 2.5;
      if (title === '3/4 Acre') return 7.5;
      if (title === '1/2 Acre') return 5;
      if (title === '1 Acre') return 10;
      const match = /^(\d+(?:\.\d+)?) Acres?$/i.exec(title || '');
      if (!match) return null;
      const tenths = Number(match[1]) * 10;
      return Number.isInteger(tenths * 10) ? tenths : null;
    }
    selection() {
      const raw = this.querySelector('[name=coverage_size]').value;
      const packet = raw === 'packet';
      const enteredArea = this.querySelector('[name=acreage]').value.trim();
      const numericArea = /^(?:\d+(?:\.\d*)?|\.\d+)$/.test(enteredArea) ? Number(enteredArea) : NaN;
      const tenths = raw === 'quarter' ? 2.5 : raw === 'other' ? Math.round(numericArea * 10) : NaN;
      const validArea = packet || raw === 'quarter' || (raw === 'other' && Number.isFinite(numericArea) && numericArea === tenths / 10 && tenths >= 5 && tenths <= 50);
      const matches = v => packet ? v.title === '1,000 sq ft' : this.coverageOf(v) === tenths;
      const base = validArea ? this.products[0]?.variants?.find(matches) : undefined;
      const quantity = Number(this.querySelector('[name=quantity]').value);
      const selected = this.dataset.optionalBase === 'true' ? Array.from(this.querySelectorAll('[data-addon]:checked'), e => Number(e.dataset.addon)) : [0, ...Array.from(this.querySelectorAll('[data-addon]:checked'), e => Number(e.dataset.addon))];
      const variants = this.products.map((p,i) => i === 0 ? base : (validArea ? p?.variants?.find(matches) : undefined));
      return {base, quantity, selected, variants, validArea, tenths, packet};
    }
    update() {
      if (this.busy) return;
      const otherArea = this.querySelector('[name=coverage_size]').value === 'other';
      const areaInput = this.querySelector('[name=acreage]');
      this.querySelector('[data-acre-control]').hidden = !otherArea;
      areaInput.disabled = !otherArea;
      areaInput.required = otherArea;
      const s = this.selection();
      areaInput.setAttribute('aria-invalid', String(otherArea && !s.validArea));
      this.querySelector('[data-area]').textContent = s.packet ? this.words.packetArea : s.validArea ? `${s.tenths / 10} acre · ${(s.tenths * 4356).toLocaleString()} sq ft` : this.words.invalidArea;

      this.querySelectorAll('[data-addon]').forEach(e => {
        const v = s.variants[Number(e.dataset.addon)];
        e.disabled = !v && !e.checked;
        this.querySelector(`[data-price="${e.dataset.addon}"]`).textContent = v ? this.format.format(v.price / 100) + (!v.available ? ' · ' + (this.words.unavailableShort || this.words.unavailable) : '') : (this.words.unavailableShort || this.words.unavailable);
      });
      const availabilityNote = this.querySelector('[data-availability-note]');
      if (availabilityNote) availabilityNote.hidden = s.variants.every(v => v?.available);
      const valid = s.selected.length > 0 && Number.isSafeInteger(s.quantity) && s.quantity > 0 && s.selected.every(i => s.variants[i]?.available);
      const sum = s.selected.reduce((n,i) => n + (s.variants[i]?.price || 0), 0);
      this.querySelector('[data-total]').textContent = !s.base || !s.selected.length ? '—' : this.format.format(sum * (Number.isSafeInteger(s.quantity) && s.quantity > 0 ? s.quantity : 1) / 100);
      const specs = this.specifications;
      const totals = s.selected.reduce((a,i) => a.map((v,j) => v + specs[i][j]), [0,0,0]);
      const speciesCount = this.querySelector('[data-species-count]');
      if (speciesCount) speciesCount.textContent = `${totals[0]} ${this.words.species}`;
      const supplementOnly = s.selected.length > 0 && (this.dataset.optionalBase !== 'true' || !s.selected.includes(0));
      const supplementNotice = this.querySelector('[data-supplement-notice]');
      if (supplementNotice) supplementNotice.hidden = !supplementOnly;
      const visibleSelection = this.querySelector('[data-selected-visible]');
      if (visibleSelection) visibleSelection.textContent = s.selected.length ? s.selected.map(i => this.products[i].title).join(' + ') : this.words.empty;
      const coverageSummary = this.querySelector('[data-coverage-summary]');
      if (coverageSummary) coverageSummary.textContent = s.validArea && Number.isSafeInteger(s.quantity) && s.quantity > 0 ? `${(s.quantity * (s.packet ? 1000 : s.tenths * 4356)).toLocaleString()} ${this.words.totalCoverage}${supplementOnly ? ' · ' + this.words.supplementCoverage : ''}` : '';
      this.querySelector('[data-specs]').textContent = `${totals[0]} ${this.words.species}; ${totals[1].toFixed(3)} ${this.words.pls}; ${totals[2].toFixed(2)} ${this.words.seeds}`;
      const selectedNames = this.querySelector('[data-selected]');
      if (selectedNames) selectedNames.textContent = s.selected.length ? s.selected.map(i => this.words.names[this.componentIndexes[i]]).join(' + ') : this.words.empty;
      const weight = this.querySelector('[data-total-pls]');
      if (weight) weight.textContent = s.validArea && s.selected.length && Number.isSafeInteger(s.quantity) && s.quantity > 0 ? (totals[1] * (s.packet ? 1000 / 43560 : s.tenths / 10) * s.quantity).toFixed(4) + ' lb PLS' : '—';
      this.renderSelectedRows(s.selected);
      this.updateGallery(s.selected);
      this.dispatchEvent(new CustomEvent('nc:seed-plan-context', {bubbles:true}));
      this.button.disabled = !valid || this.uncertain || this.dataset.previewOnly === 'true';
      if (!this.uncertain) this.status.textContent = this.unsupportedInitial ? this.words.unsupportedInitial : !s.selected.length ? this.words.empty : !s.validArea ? this.words.invalidArea : (!s.base ? this.words.unsupported : (valid ? '' : this.words.unavailable));
    }
    updateGallery(selected) {
      if (this.dataset.optionalBase !== 'true') return;
      const signature = selected.slice().sort((a,b) => a-b).join(',');
      const key = {'0':'core','0,1':'expanded','0,1,2':'maximum'}[signature];
      const gallery = document.getElementById('MediaGallery-' + this.dataset.sectionId);
      let galleryNote = gallery?.querySelector('[data-gallery-selection-note]');
      if (gallery && !galleryNote) {
        galleryNote = document.createElement('p');
        galleryNote.dataset.gallerySelectionNote = '';
        galleryNote.className = 'nc-prairie__gallery-selection-note';
        galleryNote.setAttribute('role', 'status');
        gallery.prepend(galleryNote);
      }
      if (galleryNote) {
        galleryNote.hidden = Boolean(key);
        galleryNote.textContent = selected.length ? this.words.galleryMismatch : this.words.galleryEmpty;
      }
      const note = this.querySelector('[data-image-selection-note]');
      if (note) note.hidden = true;
      const previous = this.imageSelection;
      this.imageSelection = signature;
      if (!key || previous === undefined || previous === signature) return;
      const target = gallery?.querySelector('[data-prairie-key="' + key + '"]');
      if (target && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(target.dataset.mediaId, false, { preventScroll: true });
    }

    renderSelectedRows(selected) {
      const host = this.querySelector('[data-selected-table]');
      if (!host) return;
      const detail = this.querySelector('[data-selected-details]');
      if (detail) detail.hidden = !selected.length;
      const unique = new Map();
      selected.forEach(i => {
        const component = this.componentIndexes[i];
        (this.recipeRows[component] || []).forEach(row => {
          const key = row.scientific.trim().toLowerCase();
          const value = unique.get(key) || {common:row.common,scientific:row.scientific,url:row.url,origins:[],lbs:0,seeds:0};
          value.origins.push(this.words.names[component]); value.lbs += Number(row.lbs); value.seeds += Number(row.seeds); unique.set(key,value);
        });
      });
      const table = document.createElement('table');
      const head = table.createTHead().insertRow();
      (this.words.headers || []).forEach(label => { const th=document.createElement('th'); th.scope='col'; th.textContent=label; head.append(th); });
      const body = table.createTBody();
      unique.forEach(row => {
        const tr = body.insertRow();
        const species = tr.insertCell();
        const label = row.common + ' (' + row.scientific + ')';
        if (row.url && row.url.startsWith('https://naturalcommunities.net/products/')) {
          const link = document.createElement('a'); link.href = row.url; link.textContent = label; species.append(link);
        } else species.textContent = label;
        [row.origins.join(' + '),row.lbs.toFixed(3),row.seeds.toFixed(2)].forEach(value => {tr.insertCell().textContent=value;});
      });
      host.replaceChildren(table);
    }
    async request(path, body) {
      const response = await fetch(this.dataset.root + path, {method:body ? 'POST' : 'GET', headers:{'Content-Type':'application/json','Accept':'application/json'}, credentials:'same-origin', ...(body ? {body:JSON.stringify(body)} : {})});
      const data = await response.json();
      if (!response.ok) { const error = new Error(data.description || 'Cart request failed'); error.cartResponseReceived = true; throw error; }
      return data;
    }
    async submit() {
      if (this.dataset.previewOnly === 'true' || this.busy || this.button.disabled || !this.form.reportValidity()) return;
      const s = this.selection();
      this.busy = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy','true');
      this.status.textContent = this.words.loading;
      const attempt = crypto.randomUUID();
      let attempted = false;
      let addConfirmed = false;
      try {
        const fresh = await Promise.all(s.selected.map(i => this.request('products/' + encodeURIComponent(this.products[i].handle) + '.js')));
        const current = fresh.map((p,j) => p.variants.find(v => v.id === s.variants[s.selected[j]].id));
        if (current.some(v => !v?.available)) { fresh.forEach((p,j) => { this.products[s.selected[j]] = p; }); throw new Error('Unavailable'); }
        if (current.some((v,j) => v.price !== s.variants[s.selected[j]].price)) {
          fresh.forEach((p,j) => { this.products[s.selected[j]] = p; });
          throw new Error('Price changed');
        }
        attempted = true;
        await this.request('cart/add.js', {items:current.map(v => ({id:v.id,quantity:s.quantity,properties:{'_nc_prairie_attempt':attempt}}))});
        addConfirmed = true;
        const cart = await this.request('cart.js');
        const added = cart.items.filter(v => v.properties?._nc_prairie_attempt === attempt);
        if (added.length !== current.length || added.some(v => v.quantity !== s.quantity) || current.some(v => !added.some(line => line.variant_id === v.id))) throw new Error('Incomplete mix');
        window.location.assign(this.dataset.cart);
      } catch (error) {
        let restored = !attempted;
        if (attempted) {
          try {
            const cart = await this.request('cart.js');
            const lines = cart.items.filter(v => v.properties?._nc_prairie_attempt === attempt);
            for (const line of lines) await this.request('cart/change.js', {id:line.key,quantity:0});
            const after = await this.request('cart.js');
            restored = !after.items.some(v => v.properties?._nc_prairie_attempt === attempt) && (addConfirmed || error.cartResponseReceived || lines.length > 0);
          } catch (_) { restored = false; }
        }
        this.uncertain = !restored;
        this.busy = false;
        this.update();
        this.status.textContent = !attempted ? (error.message === 'Price changed' ? this.words.priceChanged : this.words.preflightFailed) : (restored ? this.words.rolled_back : this.words.failed);
        this.querySelector('[data-review]').hidden = false;
        this.status.focus();
      } finally {
        this.form.removeAttribute('aria-busy');
      }
    }
  });
}






